// // src/components/PaymentMethods.jsx 
// import React, { useState, useEffect, useRef } from 'react';
// import { NETWORK_TYPES, TOKEN_CONFIG, detectWallets, WALLET_TYPES } from '../services/walletService';
// import { getMerchantNetworks, getMerchantTokens } from '../services/api';
// import { EthIcon, TronIcon, AlgorandIcon, SolanaIcon, BscIcon, PyusdIcon, UsdpIcon } from './icons';

// /**
//  * Payment methods component with network dropdown and currency dropdown
//  * Now uses merchant's configured networks and tokens only
//  */
// const PaymentMethods = ({ onSelect, selected, theme = 'light', supportedNetworks = [] }) => {
//   const [selectedNetwork, setSelectedNetwork] = useState(null);
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
//   const [availableWallets, setAvailableWallets] = useState({});
//   const [searchQuery, setSearchQuery] = useState('');

//   // New state for merchant's configured data
//   const [merchantNetworks, setMerchantNetworks] = useState([]);
//   const [merchantTokens, setMerchantTokens] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Custom dropdown state for networks
//   const [networkDropdownOpen, setNetworkDropdownOpen] = useState(false);
//   const networkDropdownRef = useRef(null);

//   // Custom dropdown state for currencies
//   const [currencyDropdownOpen, setCurrencyDropdownOpen] = useState(false);
//   const currencyDropdownRef = useRef(null);

//   // Load merchant's configured networks and tokens
//   useEffect(() => {
//     const loadMerchantData = async () => {
//       try {
//         setLoading(true);
// 
//         const [networks, tokens] = await Promise.all([
//           getMerchantNetworks(),
//           getMerchantTokens()
//         ]);

//         console.log('Raw merchant networks from API:', networks);
//         console.log('Raw merchant tokens from API:', tokens);

//         // Remove duplicates from networks based on shortName
//         const uniqueNetworks = networks.filter((network, index, self) => 
//           index === self.findIndex(n => n.shortName === network.shortName)
//         );

//         // Remove duplicates from tokens based on symbol + networkId combination
//         const uniqueTokens = tokens.filter((token, index, self) => 
//           index === self.findIndex(t => 
//             t.symbol === token.symbol && 
//             t.networkId === token.networkId
//           )
//         );

//         console.log('Unique merchant networks after deduplication:', uniqueNetworks);
//         console.log('Unique merchant tokens after deduplication:', uniqueTokens);

//         setMerchantNetworks(uniqueNetworks);
//         setMerchantTokens(uniqueTokens);

//         // Auto-select first available network if none selected
//         if (uniqueNetworks.length > 0 && !selectedNetwork) {
//           setSelectedNetwork(uniqueNetworks[0].shortName);
//         }

//         setError(null);
//       } catch (err) {
//         console.error('Failed to load merchant data:', err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadMerchantData();
//   }, []);

//   // Close dropdowns on outside click
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (networkDropdownRef.current && !networkDropdownRef.current.contains(event.target)) {
//         setNetworkDropdownOpen(false);
//       }
//       if (currencyDropdownRef.current && !currencyDropdownRef.current.contains(event.target)) {
//         setCurrencyDropdownOpen(false);
//       }
//     }
//     if (networkDropdownOpen || currencyDropdownOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     } else {
//       document.removeEventListener('mousedown', handleClickOutside);
//     }
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [networkDropdownOpen, currencyDropdownOpen]);

//   useEffect(() => {
//     setAvailableWallets(detectWallets());
//   }, []);

//   // Get network icon component by shortName
//   const getNetworkIcon = (shortName) => {
//     const iconMap = {
//       'ethereum': EthIcon,
//       'bsc': BscIcon,
//       'tron': TronIcon,
//       'algorand': AlgorandIcon,
//       'solana': SolanaIcon
//     };
//     return iconMap[shortName] || EthIcon;
//   };

//   // FIXED: Get token icon - returns object with type and value
// const getTokenIcon = (token) => {
//   console.log('🔍 getTokenIcon called with token:', token);
//   console.log('🔍 Token symbol:', token.symbol);
//   console.log('🔍 Token logo from backend:', token.logo);

//   // Reliable fallback images from CoinMarketCap
//   const fallbackImages = {
//     // Stablecoins
//     'USDT': 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png',
//     'USDC': 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png',
//     'DAI': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4943.png',
//     'BUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png',
//     'USDP': 'https://s2.coinmarketcap.com/static/img/coins/64x64/6958.png',
//     'PYUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/28134.png',
//     'FRAX': 'https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png',
//     'USDJ': 'https://s2.coinmarketcap.com/static/img/coins/64x64/5446.png',
//     'TUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/2563.png',

//     // Native Cryptocurrencies
//     'ETH': 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
//     'BNB': 'https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png',
//     'TRX': 'https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png',
//     'ALGO': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4030.png',
//     'SOL': 'https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png',
//     'AVAX': 'https://s2.coinmarketcap.com/static/img/coins/64x64/5805.png',
//     'MATIC': 'https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png'
//   };

//   // ALWAYS prioritize fallback images first for reliability
//   const tokenSymbol = token.symbol?.toUpperCase();
//   const fallbackUrl = fallbackImages[tokenSymbol];

//   if (fallbackUrl) {
//     console.log('✅ Using CoinMarketCap image for', tokenSymbol, ':', fallbackUrl);
//     return { type: 'image', value: fallbackUrl };
//   }

//   // Special component cases (only if no fallback exists)
//   if (tokenSymbol === 'PYUSD') {
//     console.log('✅ Using PYUSD component');
//     return { type: 'component', value: PyusdIcon };
//   }
//   if (tokenSymbol === 'USDP') {
//     console.log('✅ Using USDP component');
//     return { type: 'component', value: UsdpIcon };
//   }

//   // Backend logo as last resort
//   if (token.logo && token.logo !== '' && !token.logo.includes('placeholder')) {
//     console.log('✅ Using backend logo:', token.logo);
//     return { type: 'image', value: token.logo };
//   }

//   // Final fallback
//   const placeholder = `https://via.placeholder.com/64x64/6366f1/ffffff?text=${encodeURIComponent(tokenSymbol || '?')}`;
//   console.log('⚠️ Using placeholder for', tokenSymbol, ':', placeholder);
//   return { type: 'image', value: placeholder };
// };

//   // FIXED: Render token icon based on type
//  const renderTokenIcon = (tokenIconData, size = 32, className = "rounded-full") => {
//   console.log('🎨 renderTokenIcon called with:', tokenIconData);
//   console.log('🎨 Icon type:', tokenIconData.type);
//   console.log('🎨 Icon value:', tokenIconData.value);

//   if (tokenIconData.type === 'component') {
//     const IconComponent = tokenIconData.value;
//     console.log('🎨 Rendering component:', IconComponent);
//     return <IconComponent size={size} />;
//   } else {
//     console.log('🎨 Rendering image with URL:', tokenIconData.value);
//     return (
//       <img 
//         src={tokenIconData.value} 
//         alt="Token" 
//         className={className}
//         style={{ 
//           height: `${size}px`, 
//           width: `${size}px`,
//           objectFit: 'cover',
//           display: 'block',
//           flexShrink: 0
//         }}
//         onLoad={() => console.log('✅ Image loaded successfully:', tokenIconData.value)}
//         onError={(e) => {
//           console.error('❌ Image failed to load:', tokenIconData.value);
//           console.error('❌ Error details:', e.target.src);
//           // Fallback to a simple colored placeholder
//           e.target.src = `https://via.placeholder.com/${size}x${size}/6366f1/ffffff?text=${encodeURIComponent('?')}`;
//         }}
//       />
//     );
//   }
// };

// // DEBUGGING: Add this function to test image loading
// const testImageLoad = (url) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.onload = () => {
//       console.log('✅ Test image loaded:', url);
//       resolve(true);
//     };
//     img.onerror = () => {
//       console.error('❌ Test image failed:', url);
//       reject(false);
//     };
//     img.src = url;
//   });
// };

// // DEBUGGING: Test all fallback images (call this in useEffect for debugging)
// const testAllImages = async () => {
//   const fallbackImages = {
//     'USDT': 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png',
//     'USDC': 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png',
//     'DAI': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4943.png',
//     'BUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png',
//     'USDP': 'https://s2.coinmarketcap.com/static/img/coins/64x64/6958.png',
//     'PYUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/28134.png'
//   };

//   console.log('🧪 Testing all fallback images...');
//   for (const [symbol, url] of Object.entries(fallbackImages)) {
//     try {
//       await testImageLoad(url);
//       console.log(`✅ ${symbol}: Working`);
//     } catch {
//       console.log(`❌ ${symbol}: Failed`);
//     }
//   }
// };

//   // Filter merchant tokens for selected network and remove duplicates
//   const getPaymentMethodsForNetwork = (networkShortName) => {
//     if (!networkShortName) return [];

//     const tokensForNetwork = merchantTokens.filter(token => 
//       token.Network && token.Network.shortName === networkShortName
//     );

//     // Remove duplicates based on symbol
//     const uniqueTokens = tokensForNetwork.filter((token, index, self) => 
//       index === self.findIndex(t => t.symbol === token.symbol)
//     );

//     console.log(`Tokens for ${networkShortName} (after deduplication):`, uniqueTokens);

//     return uniqueTokens;
//   };

//   const handleNetworkChange = (networkShortName) => {
//     setSelectedNetwork(networkShortName);
//     setSelectedPaymentMethod(null); // Reset payment method selection
//   };

//   const handleSelectPaymentMethod = (token) => {
//     const tokenIconData = getTokenIcon(token);

//     const paymentMethodData = {
//       currency: token.symbol,
//       network: selectedNetwork,
//       tokenConfig: {
//         contractAddress: token.contractAddress,
//         decimals: token.decimals,
//         symbol: token.symbol,
//         ...(token.Network.type === 'algorand' && { assetId: token.contractAddress })
//       },
//       method: {
//         id: token.symbol,
//         name: token.symbol,
//         description: token.name,
//         logo: tokenIconData, // Store the icon data object
//         network: selectedNetwork,
//         isStablecoin: token.isStablecoin
//       }
//     };
//     setSelectedPaymentMethod(paymentMethodData);
//   };

//   const handleProceed = () => {
//     if (selectedPaymentMethod) {
//       onSelect(selectedPaymentMethod);
//     }
//   };

//   // Helper functions with correct wallet constants
//   function getRequiredWallet(networkShortName) {
//     switch (networkShortName) {
//       case 'ethereum':
//       case 'bsc':
//         return WALLET_TYPES.METAMASK;
//       case 'tron':
//         return WALLET_TYPES.TRONLINK;
//       case 'algorand':
//         return WALLET_TYPES.LUTE;
//       default:
//         return WALLET_TYPES.METAMASK;
//     }
//   }

//   function getNetworkRequirement(networkShortName) {
//     const wallet = getRequiredWallet(networkShortName);
//     const isAvailable = availableWallets[wallet];

//     const walletNames = {
//       [WALLET_TYPES.METAMASK]: 'MetaMask',
//       [WALLET_TYPES.TRONLINK]: 'TronLink',
//       [WALLET_TYPES.TRUST_WALLET]: 'Trust Wallet',
//       [WALLET_TYPES.LUTE]: 'Lute Wallet'
//     };

//     return isAvailable 
//       ? `${walletNames[wallet]} detected - Ready to pay`
//       : `${walletNames[wallet]} required - Please install to continue`;
//   }

//   // Show loading state
//   if (loading) {
//     return (
//       <div className="flex items-center justify-center py-8">
//         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
//         <span className="ml-2 text-gray-600">Loading payment options...</span>
//       </div>
//     );
//   }

//   // Show error state
//   if (error) {
//     return (
//       <div className="p-4 rounded-lg bg-red-100 mb-4 text-red-700 text-center">
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//         </svg>
//         <p className="font-medium">Unable to load payment options</p>
//         <p className="text-sm mt-1">{error}</p>
//       </div>
//     );
//   }

//   // Show message if no networks configured
//   if (merchantNetworks.length === 0) {
//     return (
//       <div className="p-4 rounded-lg bg-yellow-100 mb-4 text-yellow-700 text-center">
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//         </svg>
//         <p className="font-medium">No Payment Networks Configured</p>
//         <p className="text-sm mt-1">Please configure your wallet addresses in the merchant dashboard first.</p>
//       </div>
//     );
//   }

//   const availableTokensForNetwork = getPaymentMethodsForNetwork(selectedNetwork);

//   return (
//     <div className="">
//       {/* Blockchain Network Custom Dropdown */}
//       <div className="mb-6">
//         <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-white' : 'text-gray-700'}`}>
//           Blockchain Network
//         </label>
//         <div className="relative" ref={networkDropdownRef}>
//           <button
//             type="button"
//             className="w-full flex items-center justify-between py-4 bg-white rounded-2xl shadow border border-gray-200 text-gray-900 text-base font-normal focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50 transition"
//             onClick={() => setNetworkDropdownOpen((open) => !open)}
//             style={{ minHeight: '56px', padding: '0.5rem' }}
//           >
//             <span className="flex items-center gap-3">
//               {selectedNetwork ? (
//                 <>
//                   {(() => {
//                     const network = merchantNetworks.find(n => n.shortName === selectedNetwork);
//                     const IconComponent = getNetworkIcon(selectedNetwork);
//                     return <IconComponent size={32} />;
//                   })()}
//                   <span className="text-base font-normal">
//                     {merchantNetworks.find(n => n.shortName === selectedNetwork)?.name || selectedNetwork}
//                   </span>
//                 </>
//               ) : (
//                 <span className="text-gray-500">Select a network...</span>
//               )}
//             </span>
//             <svg className={`w-5 h-5 ml-2 transition-transform ${networkDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//             </svg>
//           </button>
//           {networkDropdownOpen && (
//             <div className="absolute left-0 mt-2 px-2 w-full bg-white rounded-2xl shadow-lg border border-gray-100 z-20" style={{ minWidth: '100%' }}>
//               {merchantNetworks.map((network) => {
//                 const IconComponent = getNetworkIcon(network.shortName);
//                 return (
//                   <button
//                     key={network.id}
//                     type="button"
//                     className={`w-full flex items-center gap-3 mt-1 mb-1 px-2 py-2 text-gray-900 text-base font-normal rounded-2xl transition hover:bg-gray-100 ${selectedNetwork === network.shortName ? 'bg-gray-50' : ''}`}
//                     onClick={() => {
//                       setNetworkDropdownOpen(false);
//                       handleNetworkChange(network.shortName);
//                     }}
//                     style={{ minHeight: '48px' }}
//                   >
//                     <IconComponent size={32} />
//                     <span>{network.name}</span>
//                   </button>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Stablecoins/Tokens Dropdown */}
//       {selectedNetwork && (
//         <div className="mb-4">
//           <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-white' : 'text-gray-700'}`}>
//             Choose Token
//           </label>

//           <div className="relative" ref={currencyDropdownRef}>
//             <button
//               type="button"
//               className="w-full flex items-center justify-between py-2 px-3 bg-white rounded-2xl shadow border border-gray-200 text-gray-900 text-base font-normal focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50 transition"
//               onClick={() => setCurrencyDropdownOpen((open) => !open)}
//               style={{ minHeight: '56px' }}
//             >
//               <span className="flex items-center gap-3">
//                 {selectedPaymentMethod ? (
//                   <>
//                     {renderTokenIcon(selectedPaymentMethod.method.logo, 32)}
//                     <span className="text-base font-normal">{selectedPaymentMethod.method.description} ({selectedPaymentMethod.method.name})</span>
//                   </>
//                 ) : (
//                   <span className="text-gray-500">Choose a token...</span>
//                 )}
//               </span>
//               <svg className={`w-5 h-5 ml-2 transition-transform ${currencyDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//               </svg>
//             </button>

//             {currencyDropdownOpen && (
//               <div className="absolute left-0 mt-2 px-2 w-full bg-white rounded-2xl shadow-lg border border-gray-100 z-20" style={{ minWidth: '100%' }}>
//                 {/* Search Input */}
//                 <div className="sticky top-0 bg-white pt-2 pb-2 px-2 border-b border-gray-100">
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="Search tokens..."
//                       className="w-full py-2 px-3 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50"
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                       onClick={(e) => e.stopPropagation()}
//                     />
//                   </div>
//                 </div>

//                 {/* Filtered Token List */}
//                 <div className="max-h-60 overflow-y-auto py-2">
//                   {availableTokensForNetwork
//                     .filter(token => 
//                       token.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                       token.symbol.toLowerCase().includes(searchQuery.toLowerCase())
//                     )
//                     .map((token) => {
//                       const tokenIconData = getTokenIcon(token);
//                       return (
//                         <button
//                           key={`${token.id}-${token.Network.shortName}`}
//                           type="button"
//                           className={`w-full flex items-center gap-3 mt-1 mb-1 px-2 py-2 text-gray-900 text-base font-normal rounded-2xl transition hover:bg-gray-100 ${
//                             selectedPaymentMethod?.currency === token.symbol ? 'bg-gray-50' : ''
//                           }`}
//                           onClick={() => {
//                             setCurrencyDropdownOpen(false);
//                             handleSelectPaymentMethod(token);
//                           }}
//                           style={{ minHeight: '48px' }}
//                         >
//                           {renderTokenIcon(tokenIconData, 32)}
//                           <span>{token.name} ({token.symbol})</span>
//                           {token.isStablecoin && (
//                             <span className="ml-auto text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
//                               Stablecoin
//                             </span>
//                           )}
//                         </button>
//                       );
//                     })}

//                   {/* No results message */}
//                   {availableTokensForNetwork.filter(token => 
//                     token.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                     token.symbol.toLowerCase().includes(searchQuery.toLowerCase())
//                   ).length === 0 && (
//                     <div className="text-center py-4 text-gray-500 text-sm">
//                       {searchQuery ? `No tokens found matching "${searchQuery}"` : 'No tokens configured for this network'}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Network Info */}
//       {selectedNetwork && (
//         <div className={`p-3 rounded-lg text-sm mb-6 ${
//           theme === 'dark' ? 'bg-gray-800 text-gray-300' : 'bg-gray-50 text-gray-600'
//         }`}>
//           <div className="flex items-center">
//             <div className={`w-2 h-2 rounded-full mr-2 ${
//               availableWallets[getRequiredWallet(selectedNetwork)] ? 'bg-green-500' : 'bg-red-500'
//             }`}></div>
//             <span className="text-xs">
//               {getNetworkRequirement(selectedNetwork)}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Proceed Button */}
//       <button
//         onClick={handleProceed}
//         disabled={!selectedPaymentMethod}
//         className={`w-full py-3 px-4 font-medium rounded-2xl text-lg shadow-md transition-colors ${
//           selectedPaymentMethod
//             ? 'bg-[#7042D2] text-white hover:bg-[#5b34b1]'
//             : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//         }`}
//         style={{ borderRadius: '1.5rem' }}
//       >
//         Proceed
//       </button>
//     </div>
//   );
// };

// export default PaymentMethods;




















// // src/components/PaymentMethods.jsx - Updated with Solana icon
// import React, { useState, useEffect, useRef } from 'react';
// import { NETWORK_TYPES, TOKEN_CONFIG, detectWallets, WALLET_TYPES } from '../services/walletService';
// import { getMerchantNetworks, getMerchantTokens } from '../services/api';
// import { EthIcon, TronIcon, AlgorandIcon, SolanaIcon, BscIcon, PyusdIcon, UsdpIcon } from './icons';

// /**
//  * Payment methods component with network dropdown and currency dropdown
//  * Now uses merchant's configured networks and tokens only
//  */
// const PaymentMethods = ({ onSelect, selected, theme = 'light', supportedNetworks = [] }) => {
//   const [selectedNetwork, setSelectedNetwork] = useState(null);
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
//   const [availableWallets, setAvailableWallets] = useState({});
//   const [searchQuery, setSearchQuery] = useState('');

//   // New state for merchant's configured data
//   const [merchantNetworks, setMerchantNetworks] = useState([]);
//   const [merchantTokens, setMerchantTokens] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Custom dropdown state for networks
//   const [networkDropdownOpen, setNetworkDropdownOpen] = useState(false);
//   const networkDropdownRef = useRef(null);

//   // Custom dropdown state for currencies
//   const [currencyDropdownOpen, setCurrencyDropdownOpen] = useState(false);
//   const currencyDropdownRef = useRef(null);

//   // Load merchant's configured networks and tokens
//   useEffect(() => {
//     const loadMerchantData = async () => {
//       try {
//         setLoading(true);
// 
//         const [networks, tokens] = await Promise.all([
//           getMerchantNetworks(),
//           getMerchantTokens()
//         ]);

//         console.log('Raw merchant networks from API:', networks);
//         console.log('Raw merchant tokens from API:', tokens);

//         // Remove duplicates from networks based on shortName
//         const uniqueNetworks = networks.filter((network, index, self) => 
//           index === self.findIndex(n => n.shortName === network.shortName)
//         );

//         // Remove duplicates from tokens based on symbol + networkId combination
//         const uniqueTokens = tokens.filter((token, index, self) => 
//           index === self.findIndex(t => 
//             t.symbol === token.symbol && 
//             t.networkId === token.networkId
//           )
//         );

//         console.log('Unique merchant networks after deduplication:', uniqueNetworks);
//         console.log('Unique merchant tokens after deduplication:', uniqueTokens);

//         setMerchantNetworks(uniqueNetworks);
//         setMerchantTokens(uniqueTokens);

//         // Auto-select first available network if none selected
//         if (uniqueNetworks.length > 0 && !selectedNetwork) {
//           setSelectedNetwork(uniqueNetworks[0].shortName);
//         }

//         setError(null);
//       } catch (err) {
//         console.error('Failed to load merchant data:', err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     loadMerchantData();
//   }, []);

//   // Close dropdowns on outside click
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (networkDropdownRef.current && !networkDropdownRef.current.contains(event.target)) {
//         setNetworkDropdownOpen(false);
//       }
//       if (currencyDropdownRef.current && !currencyDropdownRef.current.contains(event.target)) {
//         setCurrencyDropdownOpen(false);
//       }
//     }
//     if (networkDropdownOpen || currencyDropdownOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     } else {
//       document.removeEventListener('mousedown', handleClickOutside);
//     }
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [networkDropdownOpen, currencyDropdownOpen]);

//   useEffect(() => {
//     setAvailableWallets(detectWallets());
//   }, []);

//   // Get network icon component by shortName - Added Solana
//   const getNetworkIcon = (shortName) => {
//     const iconMap = {
//       'ethereum': EthIcon,
//       'bsc': BscIcon,
//       'tron': TronIcon,
//       'algorand': AlgorandIcon,
//       'solana': SolanaIcon
//     };
//     return iconMap[shortName] || EthIcon;
//   };

//   // Get token icon - returns object with type and value
//   const getTokenIcon = (token) => {
// //     console.log('🔍 Token symbol:', token.symbol);
//     console.log('🔍 Token logo from backend:', token.logo);

//     // Reliable fallback images from CoinMarketCap
//     const fallbackImages = {
//       // Stablecoins
//       'USDT': 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png',
//       'USDC': 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png',
//       'DAI': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4943.png',
//       'BUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png',
//       'USDP': 'https://s2.coinmarketcap.com/static/img/coins/64x64/6958.png',
//       'PYUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/28134.png',
//       'FRAX': 'https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png',
//       'USDJ': 'https://s2.coinmarketcap.com/static/img/coins/64x64/5446.png',
//       'TUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/2563.png',

//       // Native Cryptocurrencies
//       'ETH': 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
//       'BNB': 'https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png',
//       'TRX': 'https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png',
//       'ALGO': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4030.png',
//       'SOL': 'https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png',
//       'AVAX': 'https://s2.coinmarketcap.com/static/img/coins/64x64/5805.png',
//       'MATIC': 'https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png'
//     };

//     // ALWAYS prioritize fallback images first for reliability
//     const tokenSymbol = token.symbol?.toUpperCase();
//     const fallbackUrl = fallbackImages[tokenSymbol];

//     if (fallbackUrl) {
// //       return { type: 'image', value: fallbackUrl };
//     }

//     // Special component cases (only if no fallback exists)
//     if (tokenSymbol === 'PYUSD') {
// //       return { type: 'component', value: PyusdIcon };
//     }
//     if (tokenSymbol === 'USDP') {
// //       return { type: 'component', value: UsdpIcon };
//     }

//     // Backend logo as last resort
//     if (token.logo && token.logo !== '' && !token.logo.includes('placeholder')) {
// //       return { type: 'image', value: token.logo };
//     }

//     // Final fallback
//     const placeholder = `https://via.placeholder.com/64x64/6366f1/ffffff?text=${encodeURIComponent(tokenSymbol || '?')}`;
// //     return { type: 'image', value: placeholder };
//   };

//   // Render token icon based on type
//   const renderTokenIcon = (tokenIconData, size = 32, className = "rounded-full") => {
// //     console.log('🎨 Icon type:', tokenIconData.type);
//     console.log('🎨 Icon value:', tokenIconData.value);

//     if (tokenIconData.type === 'component') {
//       const IconComponent = tokenIconData.value;
// //       return <IconComponent size={size} />;
//     } else {
// //       return (
//         <img 
//           src={tokenIconData.value} 
//           alt="Token" 
//           className={className}
//           style={{ 
//             height: `${size}px`, 
//             width: `${size}px`,
//             objectFit: 'cover',
//             display: 'block',
//             flexShrink: 0
//           }}
//           onLoad={() => {}}
//           onError={(e) => {
//             console.error('❌ Image failed to load:', tokenIconData.value);
//             console.error('❌ Error details:', e.target.src);
//             // Fallback to a simple colored placeholder
//             e.target.src = `https://via.placeholder.com/${size}x${size}/6366f1/ffffff?text=${encodeURIComponent('?')}`;
//           }}
//         />
//       );
//     }
//   };

//   // Filter merchant tokens for selected network and remove duplicates
//   const getPaymentMethodsForNetwork = (networkShortName) => {
//     if (!networkShortName) return [];

//     const tokensForNetwork = merchantTokens.filter(token => 
//       token.Network && token.Network.shortName === networkShortName
//     );

//     // Remove duplicates based on symbol
//     const uniqueTokens = tokensForNetwork.filter((token, index, self) => 
//       index === self.findIndex(t => t.symbol === token.symbol)
//     );

//     console.log(`Tokens for ${networkShortName} (after deduplication):`, uniqueTokens);

//     return uniqueTokens;
//   };

//   const handleNetworkChange = (networkShortName) => {
//     setSelectedNetwork(networkShortName);
//     setSelectedPaymentMethod(null); // Reset payment method selection
//   };

//   // const handleSelectPaymentMethod = (token) => {
//   //   const tokenIconData = getTokenIcon(token);



//   //   const paymentMethodData = {
//   //     currency: token.symbol,
//   //     network: selectedNetwork,
//   //     tokenConfig: {
//   //       contractAddress: token.contractAddress,
//   //       decimals: token.decimals,
//   //       symbol: token.symbol,
//   //       ...(token.Network.type === 'algorand' && { assetId: token.contractAddress })
//   //     },
//   //     method: {
//   //       id: token.symbol,
//   //       name: token.symbol,
//   //       description: token.name,
//   //       logo: tokenIconData, // Store the icon data object
//   //       network: selectedNetwork,
//   //       isStablecoin: token.isStablecoin
//   //     }
//   //   };
//   //   setSelectedPaymentMethod(paymentMethodData);
//   // };

// const handleSelectPaymentMethod = (token) => {
//   const tokenIconData = getTokenIcon(token);

//   console.log('=== PAYMENT METHOD SELECTION DEBUG ===');
//   console.log('Selected token:', token);
//   console.log('Selected network:', selectedNetwork);
//   console.log('Token network:', token.Network?.shortName);

//   const paymentMethodData = {
//     currency: token.symbol,
//     network: selectedNetwork, // ✅ Use the selectedNetwork state, not token.Network.shortName
//     tokenConfig: {
//       contractAddress: token.contractAddress,
//       decimals: token.decimals,
//       symbol: token.symbol,
//       ...(token.Network.type === 'algorand' && { assetId: token.contractAddress })
//     },
//     method: {
//       id: token.symbol,
//       name: token.symbol,
//       description: token.name,
//       logo: tokenIconData, // Store the icon data object
//       network: selectedNetwork, // ✅ Use selectedNetwork here too
//       isStablecoin: token.isStablecoin
//     }
//   };

//   console.log('🎯 FINAL PAYMENT METHOD DATA:', paymentMethodData);
//   console.log('🎯 Network being set:', paymentMethodData.network);
//   console.log('=== END PAYMENT METHOD SELECTION DEBUG ===');

//   setSelectedPaymentMethod(paymentMethodData);
// };

//   const handleProceed = () => {
//     if (selectedPaymentMethod) {
//       onSelect(selectedPaymentMethod);
//     }
//   };

//   // Helper functions with correct wallet constants - Added Phantom
//   function getRequiredWallet(networkShortName) {
//     switch (networkShortName) {
//       case 'ethereum':
//       case 'bsc':
//         return WALLET_TYPES.METAMASK;
//       case 'tron':
//         return WALLET_TYPES.TRONLINK;
//       case 'algorand':
//         return WALLET_TYPES.LUTE;
//       case 'solana':
//         return WALLET_TYPES.PHANTOM;
//       default:
//         return WALLET_TYPES.METAMASK;
//     }
//   }

//   function getNetworkRequirement(networkShortName) {
//     const wallet = getRequiredWallet(networkShortName);
//     const isAvailable = availableWallets[wallet];

//     const walletNames = {
//       [WALLET_TYPES.METAMASK]: 'MetaMask',
//       [WALLET_TYPES.TRONLINK]: 'TronLink',
//       [WALLET_TYPES.TRUST_WALLET]: 'Trust Wallet',
//       [WALLET_TYPES.LUTE]: 'Lute Wallet',
//       [WALLET_TYPES.PHANTOM]: 'Phantom'
//     };

//     return isAvailable 
//       ? `${walletNames[wallet]} detected - Ready to pay`
//       : `${walletNames[wallet]} required - Please install to continue`;
//   }

//   // Show loading state
//   if (loading) {
//     return (
//       <div className="flex items-center justify-center py-8">
//         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
//         <span className="ml-2 text-gray-600">Loading payment options...</span>
//       </div>
//     );
//   }

//   // Show error state
//   if (error) {
//     return (
//       <div className="p-4 rounded-lg bg-red-100 mb-4 text-red-700 text-center">
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//         </svg>
//         <p className="font-medium">Unable to load payment options</p>
//         <p className="text-sm mt-1">{error}</p>
//       </div>
//     );
//   }

//   // Show message if no networks configured
//   if (merchantNetworks.length === 0) {
//     return (
//       <div className="p-4 rounded-lg bg-yellow-100 mb-4 text-yellow-700 text-center">
//         <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//         </svg>
//         <p className="font-medium">No Payment Networks Configured</p>
//         <p className="text-sm mt-1">Please configure your wallet addresses in the merchant dashboard first.</p>
//       </div>
//     );
//   }

//   const availableTokensForNetwork = getPaymentMethodsForNetwork(selectedNetwork);

//   return (
//     <div className="">
//       {/* Blockchain Network Custom Dropdown */}
//       <div className="mb-6">
//         <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-white' : 'text-gray-700'}`}>
//           Blockchain Network
//         </label>
//         <div className="relative" ref={networkDropdownRef}>
//           <button
//             type="button"
//             className="w-full flex items-center justify-between py-4 bg-white rounded-2xl shadow border border-gray-200 text-gray-900 text-base font-normal focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50 transition"
//             onClick={() => setNetworkDropdownOpen((open) => !open)}
//             style={{ minHeight: '56px', padding: '0.5rem' }}
//           >
//             <span className="flex items-center gap-3">
//               {selectedNetwork ? (
//                 <>
//                   {(() => {
//                     const network = merchantNetworks.find(n => n.shortName === selectedNetwork);
//                     const IconComponent = getNetworkIcon(selectedNetwork);
//                     return <IconComponent size={32} />;
//                   })()}
//                   <span className="text-base font-normal">
//                     {merchantNetworks.find(n => n.shortName === selectedNetwork)?.name || selectedNetwork}
//                   </span>
//                 </>
//               ) : (
//                 <span className="text-gray-500">Select a network...</span>
//               )}
//             </span>
//             <svg className={`w-5 h-5 ml-2 transition-transform ${networkDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//             </svg>
//           </button>
//           {networkDropdownOpen && (
//             <div className="absolute left-0 mt-2 px-2 w-full bg-white rounded-2xl shadow-lg border border-gray-100 z-20" style={{ minWidth: '100%' }}>
//               {merchantNetworks.map((network) => {
//                 const IconComponent = getNetworkIcon(network.shortName);
//                 return (
//                   <button
//                     key={network.id}
//                     type="button"
//                     className={`w-full flex items-center gap-3 mt-1 mb-1 px-2 py-2 text-gray-900 text-base font-normal rounded-2xl transition hover:bg-gray-100 ${selectedNetwork === network.shortName ? 'bg-gray-50' : ''}`}
//                     onClick={() => {
//                       setNetworkDropdownOpen(false);
//                       handleNetworkChange(network.shortName);
//                     }}
//                     style={{ minHeight: '48px' }}
//                   >
//                     <IconComponent size={32} />
//                     <span>{network.name}</span>
//                   </button>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Stablecoins/Tokens Dropdown */}
//       {selectedNetwork && (
//         <div className="mb-4">
//           <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-white' : 'text-gray-700'}`}>
//             Choose Token
//           </label>

//           <div className="relative" ref={currencyDropdownRef}>
//             <button
//               type="button"
//               className="w-full flex items-center justify-between py-2 px-3 bg-white rounded-2xl shadow border border-gray-200 text-gray-900 text-base font-normal focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50 transition"
//               onClick={() => setCurrencyDropdownOpen((open) => !open)}
//               style={{ minHeight: '56px' }}
//             >
//               <span className="flex items-center gap-3">
//                 {selectedPaymentMethod ? (
//                   <>
//                     {renderTokenIcon(selectedPaymentMethod.method.logo, 32)}
//                     <span className="text-base font-normal">{selectedPaymentMethod.method.description} ({selectedPaymentMethod.method.name})</span>
//                   </>
//                 ) : (
//                   <span className="text-gray-500">Choose a token...</span>
//                 )}
//               </span>
//               <svg className={`w-5 h-5 ml-2 transition-transform ${currencyDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//               </svg>
//             </button>

//             {currencyDropdownOpen && (
//               <div className="absolute left-0 mt-2 px-2 w-full bg-white rounded-2xl shadow-lg border border-gray-100 z-20" style={{ minWidth: '100%' }}>
//                 {/* Search Input */}
//                 <div className="sticky top-0 bg-white pt-2 pb-2 px-2 border-b border-gray-100">
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="Search tokens..."
//                       className="w-full py-2 px-3 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50"
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                       onClick={(e) => e.stopPropagation()}
//                     />
//                   </div>
//                 </div>

//                 {/* Filtered Token List */}
//                 <div className="max-h-60 overflow-y-auto py-2">
//                   {availableTokensForNetwork
//                     .filter(token => 
//                       token.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                       token.symbol.toLowerCase().includes(searchQuery.toLowerCase())
//                     )
//                     .map((token) => {
//                       const tokenIconData = getTokenIcon(token);
//                       return (
//                         <button
//                           key={`${token.id}-${token.Network.shortName}`}
//                           type="button"
//                           className={`w-full flex items-center gap-3 mt-1 mb-1 px-2 py-2 text-gray-900 text-base font-normal rounded-2xl transition hover:bg-gray-100 ${
//                             selectedPaymentMethod?.currency === token.symbol ? 'bg-gray-50' : ''
//                           }`}
//                           onClick={() => {
//                             setCurrencyDropdownOpen(false);
//                             handleSelectPaymentMethod(token);
//                           }}
//                           style={{ minHeight: '48px' }}
//                         >
//                           {renderTokenIcon(tokenIconData, 32)}
//                           <span>{token.name} ({token.symbol})</span>
//                           {token.isStablecoin && (
//                             <span className="ml-auto text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
//                               Stablecoin
//                             </span>
//                           )}
//                         </button>
//                       );
//                     })}

//                   {/* No results message */}
//                   {availableTokensForNetwork.filter(token => 
//                     token.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                     token.symbol.toLowerCase().includes(searchQuery.toLowerCase())
//                   ).length === 0 && (
//                     <div className="text-center py-4 text-gray-500 text-sm">
//                       {searchQuery ? `No tokens found matching "${searchQuery}"` : 'No tokens configured for this network'}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Network Info */}
//       {selectedNetwork && (
//         <div className={`p-3 rounded-lg text-sm mb-6 ${
//           theme === 'dark' ? 'bg-gray-800 text-gray-300' : 'bg-gray-50 text-gray-600'
//         }`}>
//           <div className="flex items-center">
//             <div className={`w-2 h-2 rounded-full mr-2 ${
//               availableWallets[getRequiredWallet(selectedNetwork)] ? 'bg-green-500' : 'bg-red-500'
//             }`}></div>
//             <span className="text-xs">
//               {getNetworkRequirement(selectedNetwork)}
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Proceed Button */}
//       <button
//         onClick={handleProceed}
//         disabled={!selectedPaymentMethod}
//         className={`w-full py-3 px-4 font-medium rounded-2xl text-lg shadow-md transition-colors ${
//           selectedPaymentMethod
//             ? 'bg-[#7042D2] text-white hover:bg-[#5b34b1]'
//             : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//         }`}
//         style={{ borderRadius: '1.5rem' }}
//       >
//         Proceed
//       </button>
//     </div>
//   );
// };

// export default PaymentMethods;















// src/components/PaymentMethods.jsx - Fixed dropdown height and RLUSD filtering
import React, { useState, useEffect, useRef } from 'react';
import { 
  NETWORK_TYPES, 
  TOKEN_CONFIG, 
  detectWallets, 
  WALLET_TYPES,
  useWalletDetection,
  isEvmNetwork
} from '../services/walletCoreService';
import { getMerchantNetworks, getMerchantTokens } from '../services/api';
import { EthIcon, TronIcon, AlgorandIcon, SolanaIcon, BscIcon, PyusdIcon, UsdpIcon } from './icons';

/**
 * Payment methods component with network dropdown and currency dropdown
 * Now uses merchant's configured networks and tokens only
 */
const PaymentMethods = ({ onSelect, selected, theme = 'light', supportedNetworks = [] }) => {
  const [selectedNetwork, setSelectedNetwork] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [availableWallets, setAvailableWallets] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  
  // Modern wallet detection hook
  const { detectedWallets } = useWalletDetection();

  // New state for merchant's configured data
  const [merchantNetworks, setMerchantNetworks] = useState([]);
  const [merchantTokens, setMerchantTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Custom dropdown state for networks
  const [networkDropdownOpen, setNetworkDropdownOpen] = useState(false);
  const networkDropdownRef = useRef(null);

  // Custom dropdown state for currencies
  const [currencyDropdownOpen, setCurrencyDropdownOpen] = useState(false);
  const currencyDropdownRef = useRef(null);

  // 🔧 NEW: Filter function to remove RLUSD tokens
  const filterOutRLUSD = (tokens) => {
    return tokens.filter(token => {
      // Remove RLUSD (Raft Locked USDC) tokens
      const isRLUSD = token.symbol?.toUpperCase() === 'RLUSD' ||
        token.name?.toLowerCase().includes('raft locked') ||
        token.name?.toLowerCase().includes('rlusd');

      if (isRLUSD) {
      }

      return !isRLUSD;
    });
  };

  // Load merchant's configured networks and tokens
  useEffect(() => {
    const loadMerchantData = async () => {
      try {
        setLoading(true);

        const [networks, tokens] = await Promise.all([
          getMerchantNetworks(),
          getMerchantTokens()
        ]);


        // 🚫 FILTER OUT RLUSD TOKENS
        const filteredTokens = tokens.filter(token => {
          const symbol = token.symbol?.toUpperCase();
          const name = token.name?.toLowerCase();

          // Remove RLUSD and any Raft Locked tokens
          const isRLUSD = symbol === 'RLUSD' ||
            name?.includes('raft locked') ||
            name?.includes('rlusd');

          if (isRLUSD) {
              }

          return !isRLUSD;
        });


        // Remove duplicates from networks based on shortName
        const uniqueNetworks = networks.filter((network, index, self) =>
          index === self.findIndex(n => n.shortName === network.shortName)
        );

        // Remove duplicates from tokens based on symbol + networkId combination
        const uniqueTokens = filteredTokens.filter((token, index, self) =>
          index === self.findIndex(t =>
            t.symbol === token.symbol &&
            t.networkId === token.networkId
          )
        );


        setMerchantNetworks(uniqueNetworks);
        setMerchantTokens(uniqueTokens);

        // Auto-select first available network if none selected
        if (uniqueNetworks.length > 0 && !selectedNetwork) {
          setSelectedNetwork(uniqueNetworks[0].shortName);
        }

        setError(null);
      } catch (err) {
        console.error('Failed to load merchant data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadMerchantData();
  }, []);

  // Close dropdowns on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (networkDropdownRef.current && !networkDropdownRef.current.contains(event.target)) {
        setNetworkDropdownOpen(false);
      }
      if (currencyDropdownRef.current && !currencyDropdownRef.current.contains(event.target)) {
        setCurrencyDropdownOpen(false);
      }
    }
    if (networkDropdownOpen || currencyDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [networkDropdownOpen, currencyDropdownOpen]);

  // ✅ ENHANCED: Modern wallet detection with wallet-connect-core integration
  useEffect(() => {
    const detectWalletsEnhanced = async () => {
      try {
        
        // Combine modern detection (EVM wallets) with legacy detection (non-EVM)
        const [modernWallets, legacyWallets] = await Promise.allSettled([
          // Modern detection from wallet-connect-core
          Promise.resolve(detectedWallets || []),
          // Legacy detection for non-EVM wallets
          detectWallets()
        ]);
        
        // Convert modern detected wallets to the expected format
        const evmWallets = {};
        if (modernWallets.status === 'fulfilled' && modernWallets.value) {
          modernWallets.value.forEach(wallet => {
            if (wallet.name.toLowerCase().includes('metamask')) {
              evmWallets[WALLET_TYPES.METAMASK] = true;
            } else if (wallet.name.toLowerCase().includes('coinbase')) {
              evmWallets[WALLET_TYPES.COINBASE_WALLET] = true;
            } else if (wallet.name.toLowerCase().includes('trust')) {
              evmWallets[WALLET_TYPES.TRUST_WALLET] = true;
            }
          });
        }
        
        // Merge with legacy detection results
        const legacyResult = legacyWallets.status === 'fulfilled' ? legacyWallets.value : {};
        
        const allWallets = {
          ...legacyResult,
          ...evmWallets
        };
        
        setAvailableWallets(allWallets);
        
      } catch (error) {
        console.error('PaymentMethods: Error detecting wallets:', error);
        // Fallback to basic detection
        const fallbackWallets = {
          [WALLET_TYPES.METAMASK]: typeof window.ethereum !== 'undefined',
          [WALLET_TYPES.PHANTOM]: typeof window.solana !== 'undefined',
          [WALLET_TYPES.TRONLINK]: typeof window.tronWeb !== 'undefined',
          [WALLET_TYPES.TRUST_WALLET]: false,
          [WALLET_TYPES.LUTE]: false
        };
        setAvailableWallets(fallbackWallets);
      }
    };
    
    detectWalletsEnhanced();
  }, [detectedWallets]);

  // Get network icon component by shortName - Added Solana
  const getNetworkIcon = (shortName) => {
    const iconMap = {
      'ethereum': EthIcon,
      'bsc': BscIcon,
      'tron': TronIcon,
      'algorand': AlgorandIcon,
      'solana': SolanaIcon
    };
    return iconMap[shortName] || EthIcon;
  };

  // Get token icon - returns object with type and value
  const getTokenIcon = (token) => {

    // Reliable fallback images from CoinMarketCap
    const fallbackImages = {
      // Stablecoins
      'USDT': 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png',
      'USDC': 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png',
      'DAI': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4943.png',
      'BUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4687.png',
      'USDP': 'https://s2.coinmarketcap.com/static/img/coins/64x64/6958.png',
      'PYUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/28134.png',
      'FRAX': 'https://s2.coinmarketcap.com/static/img/coins/64x64/6952.png',
      'USDJ': 'https://s2.coinmarketcap.com/static/img/coins/64x64/5446.png',
      'TUSD': 'https://s2.coinmarketcap.com/static/img/coins/64x64/2563.png',

      // Native Cryptocurrencies
      'ETH': 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      'BNB': 'https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png',
      'TRX': 'https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png',
      'ALGO': 'https://s2.coinmarketcap.com/static/img/coins/64x64/4030.png',
      'SOL': 'https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png',
      'AVAX': 'https://s2.coinmarketcap.com/static/img/coins/64x64/5805.png',
      'MATIC': 'https://s2.coinmarketcap.com/static/img/coins/64x64/3890.png'
    };

    // ALWAYS prioritize fallback images first for reliability
    const tokenSymbol = token.symbol?.toUpperCase();
    const fallbackUrl = fallbackImages[tokenSymbol];

    if (fallbackUrl) {
      return { type: 'image', value: fallbackUrl };
    }

    // Special component cases (only if no fallback exists)
    if (tokenSymbol === 'PYUSD') {
      return { type: 'component', value: PyusdIcon };
    }
    if (tokenSymbol === 'USDP') {
      return { type: 'component', value: UsdpIcon };
    }

    // Backend logo as last resort
    if (token.logo && token.logo !== '' && !token.logo.includes('placeholder')) {
      return { type: 'image', value: token.logo };
    }

    // Final fallback
    const placeholder = `https://via.placeholder.com/64x64/6366f1/ffffff?text=${encodeURIComponent(tokenSymbol || '?')}`;
    return { type: 'image', value: placeholder };
  };

  // Render token icon based on type
  const renderTokenIcon = (tokenIconData, size = 32, className = "rounded-full") => {

    if (tokenIconData.type === 'component') {
      const IconComponent = tokenIconData.value;
      return <IconComponent size={size} />;
    } else {
      return (
        <img
          src={tokenIconData.value}
          alt="Token"
          className={className}
          style={{
            height: `${size}px`,
            width: `${size}px`,
            objectFit: 'cover',
            display: 'block',
            flexShrink: 0
          }}
          onLoad={() => {}}
          onError={(e) => {
            console.error('❌ Image failed to load:', tokenIconData.value);
            console.error('❌ Error details:', e.target.src);
            // Fallback to a simple colored placeholder
            e.target.src = `https://via.placeholder.com/${size}x${size}/6366f1/ffffff?text=${encodeURIComponent('?')}`;
          }}
        />
      );
    }
  };

  // Filter merchant tokens for selected network and remove duplicates (with RLUSD already filtered out)
  const getPaymentMethodsForNetwork = (networkShortName) => {
    if (!networkShortName) return [];

    const tokensForNetwork = merchantTokens.filter(token =>
      token.Network && token.Network.shortName === networkShortName
    );

    // Remove duplicates based on symbol
    const uniqueTokens = tokensForNetwork.filter((token, index, self) =>
      index === self.findIndex(t => t.symbol === token.symbol)
    );


    return uniqueTokens;
  };

  const handleNetworkChange = (networkShortName) => {
    setSelectedNetwork(networkShortName);
    setSelectedPaymentMethod(null); // Reset payment method selection
  };

  const handleSelectPaymentMethod = (token) => {
    const tokenIconData = getTokenIcon(token);


    const paymentMethodData = {
      currency: token.symbol,
      network: selectedNetwork, // ✅ Use the selectedNetwork state, not token.Network.shortName
      tokenConfig: {
        contractAddress: token.contractAddress,
        decimals: token.decimals,
        symbol: token.symbol,
        ...(token.Network.type === 'algorand' && { assetId: token.contractAddress })
      },
      method: {
        id: token.symbol,
        name: token.symbol,
        description: token.name,
        logo: tokenIconData, // Store the icon data object
        network: selectedNetwork, // ✅ Use selectedNetwork here too
        isStablecoin: token.isStablecoin
      }
    };


    setSelectedPaymentMethod(paymentMethodData);
  };

  const handleProceed = () => {
    if (selectedPaymentMethod) {
      onSelect(selectedPaymentMethod);
    }
  };

  // Helper functions with correct wallet constants - Added Phantom
  function getRequiredWallet(networkShortName) {
    switch (networkShortName) {
      case 'ethereum':
      case 'bsc':
        return WALLET_TYPES.METAMASK;
      case 'tron':
        return WALLET_TYPES.TRONLINK;
      case 'algorand':
        return WALLET_TYPES.LUTE;
      case 'solana':
        return WALLET_TYPES.PHANTOM;
      default:
        return WALLET_TYPES.METAMASK;
    }
  }

  function getNetworkRequirement(networkShortName) {
    const wallet = getRequiredWallet(networkShortName);
    const isAvailable = availableWallets[wallet];

    const walletNames = {
      [WALLET_TYPES.METAMASK]: 'MetaMask',
      [WALLET_TYPES.TRONLINK]: 'TronLink',
      [WALLET_TYPES.TRUST_WALLET]: 'Trust Wallet',
      [WALLET_TYPES.LUTE]: 'Lute Wallet',
      [WALLET_TYPES.PHANTOM]: 'Phantom'
    };

    return isAvailable
      ? `${walletNames[wallet]} detected - Ready to pay`
      : `${walletNames[wallet]} required - Please install to continue`;
  }

  // Show loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
        <span className="ml-2 text-gray-600">Loading payment options...</span>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="p-4 rounded-lg bg-red-100 mb-4 text-red-700 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <p className="font-medium">Unable to load payment options</p>
        <p className="text-sm mt-1">{error}</p>
      </div>
    );
  }

  // Show message if no networks configured
  if (merchantNetworks.length === 0) {
    return (
      <div className="p-4 rounded-lg bg-yellow-100 mb-4 text-yellow-700 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <p className="font-medium">No Payment Networks Configured</p>
        <p className="text-sm mt-1">Please configure your wallet addresses in the merchant dashboard first.</p>
      </div>
    );
  }

  const availableTokensForNetwork = getPaymentMethodsForNetwork(selectedNetwork);

  return (
    <div className="">
      {/* Blockchain Network Custom Dropdown */}
      <div className="mb-6">
        <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-white' : 'text-gray-700'}`}>
          Blockchain Network
        </label>
        <div className="relative" ref={networkDropdownRef}>
          <button
            type="button"
            className="w-full flex items-center justify-between py-4 bg-white rounded-2xl shadow border border-gray-200 text-gray-900 text-base font-normal focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50 transition"
            onClick={() => setNetworkDropdownOpen((open) => !open)}
            style={{ minHeight: '56px', padding: '0.5rem' }}
          >
            <span className="flex items-center gap-3">
              {selectedNetwork ? (
                <>
                  {(() => {
                    const network = merchantNetworks.find(n => n.shortName === selectedNetwork);
                    const IconComponent = getNetworkIcon(selectedNetwork);
                    return <IconComponent size={32} />;
                  })()}
                  <span className="text-base font-normal">
                    {merchantNetworks.find(n => n.shortName === selectedNetwork)?.name || selectedNetwork}
                  </span>
                </>
              ) : (
                <span className="text-gray-500">Select a network...</span>
              )}
            </span>
            <svg className={`w-5 h-5 ml-2 transition-transform ${networkDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {networkDropdownOpen && (
            <div className="absolute left-0 mt-2 px-2 w-full bg-white rounded-2xl shadow-lg border border-gray-100 z-20" style={{ minWidth: '100%' }}>
              {merchantNetworks.map((network) => {
                const IconComponent = getNetworkIcon(network.shortName);
                return (
                  <button
                    key={network.id}
                    type="button"
                    className={`w-full flex items-center gap-3 mt-1 mb-1 px-2 py-2 text-gray-900 text-base font-normal rounded-2xl transition hover:bg-gray-100 ${selectedNetwork === network.shortName ? 'bg-gray-50' : ''}`}
                    onClick={() => {
                      setNetworkDropdownOpen(false);
                      handleNetworkChange(network.shortName);
                    }}
                    style={{ minHeight: '48px' }}
                  >
                    <IconComponent size={32} />
                    <span>{network.name}</span>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Stablecoins/Tokens Dropdown - FIXED HEIGHT ISSUE */}
      {selectedNetwork && (
        <div className="mb-4">
          <label className={`block text-sm font-medium mb-2 ${theme === 'dark' ? 'text-white' : 'text-gray-700'}`}>
            Choose Token
          </label>

          <div className="relative" ref={currencyDropdownRef}>
            <button
              type="button"
              className="w-full flex items-center justify-between py-2 px-3 bg-white rounded-2xl shadow border border-gray-200 text-gray-900 text-base font-normal focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50 transition"
              onClick={() => setCurrencyDropdownOpen((open) => !open)}
              style={{ minHeight: '56px' }}
            >
              <span className="flex items-center gap-3">
                {selectedPaymentMethod ? (
                  <>
                    {renderTokenIcon(selectedPaymentMethod.method.logo, 32)}
                    <span className="text-base font-normal">{selectedPaymentMethod.method.description} ({selectedPaymentMethod.method.name})</span>
                  </>
                ) : (
                  <span className="text-gray-500">Choose a token...</span>
                )}
              </span>
              <svg className={`w-5 h-5 ml-2 transition-transform ${currencyDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {currencyDropdownOpen && (
              <div className="absolute left-0 mt-2 px-2 w-full bg-white rounded-2xl shadow-lg border border-gray-100 z-20" style={{ minWidth: '100%' }}>
                {/* Search Input */}
                <div className="sticky top-0 bg-white pt-2 pb-2 px-2 border-b border-gray-100">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search tokens..."
                      className="w-full py-2 px-3 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#7042D2] focus:ring-opacity-50"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                </div>

                {/* 🔧 FIXED: Dynamic height container instead of max-h-60 */}

                {/* Token List - WITH DUMMY SPACERS AND SCROLLING */}
                <div
                  className="py-2 overflow-y-auto"
                  style={{
                    maxHeight: '240px',
                    overflowX: 'hidden'
                  }}
                >
                  {availableTokensForNetwork
                    .filter(token =>
                      token.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                      token.symbol.toLowerCase().includes(searchQuery.toLowerCase())
                    )
                    .map((token) => {
                      const tokenIconData = getTokenIcon(token);
                      return (
                        <button
                          key={`${token.id}-${token.Network.shortName}`}
                          type="button"
                          className={`w-full flex items-center gap-3 mt-1 mb-1 px-2 py-2 text-gray-900 text-base font-normal rounded-2xl transition hover:bg-gray-100 ${selectedPaymentMethod?.currency === token.symbol ? 'bg-gray-50' : ''
                            }`}
                          onClick={() => {
                            setCurrencyDropdownOpen(false);
                            handleSelectPaymentMethod(token);
                          }}
                          style={{ minHeight: '48px' }}
                        >
                          {renderTokenIcon(tokenIconData, 32)}
                          <span>{token.name} ({token.symbol})</span>
                          {token.isStablecoin && (
                            <span className="ml-auto text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                              Stablecoin
                            </span>
                          )}
                        </button>
                      );
                    })}

                  {/* Dummy spacer tokens to push content up - ONLY if we have more than 3 tokens */}
                  {availableTokensForNetwork.length > 3 && (
                    <>
                      <div style={{ height: '42px', visibility: 'hidden' }}></div>
                      <div style={{ height: '42px', visibility: 'hidden' }}></div>
                    </>
                  )}

                  {/* No results message */}
                  {availableTokensForNetwork.filter(token =>
                    token.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    token.symbol.toLowerCase().includes(searchQuery.toLowerCase())
                  ).length === 0 && (
                      <div className="text-center py-4 text-gray-500 text-sm">
                        {searchQuery ? `No tokens found matching "${searchQuery}"` : 'No tokens configured for this network'}
                      </div>
                    )}
                </div>


              </div>
            )}
          </div>
        </div>
      )}

      {/* Network Info */}
      {selectedNetwork && (
        <div className={`p-3 rounded-lg text-sm mb-6 ${theme === 'dark' ? 'bg-gray-800 text-gray-300' : 'bg-gray-50 text-gray-600'
          }`}>
          <div className="flex items-center">
            <div className={`w-2 h-2 rounded-full mr-2 ${availableWallets[getRequiredWallet(selectedNetwork)] ? 'bg-green-500' : 'bg-red-500'
              }`}></div>
            <span className="text-xs">
              {getNetworkRequirement(selectedNetwork)}
            </span>
          </div>
        </div>
      )}

      {/* Proceed Button */}
      <button
        onClick={handleProceed}
        disabled={!selectedPaymentMethod}
        className={`w-full py-3 px-4 font-medium rounded-2xl text-lg shadow-md transition-colors ${selectedPaymentMethod
            ? 'bg-[#7042D2] text-white hover:bg-[#5b34b1]'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        style={{ borderRadius: '1.5rem' }}
      >
        Proceed
      </button>
    </div>
  );
};

export default PaymentMethods;